globalThis.DeviceQueries = (function(){
    function DeviceQueries() { }

    DeviceQueries.tactilClass = 'tactil-device';

    DeviceQueries.init = function(){
      if(DeviceQueries.isTactilDevice()) {
        $('body').addClass(DeviceQueries.tactilClass);
      } else {
        $('body').removeClass(DeviceQueries.tactilClass);
      }
    }

    DeviceQueries.isTactilDevice = function(){
      var deviceAgent = navigator.userAgent.toLowerCase();
      if(Modernizr.touch ||
      (deviceAgent.match(/(iphone|ipod|ipad)/) ||
      deviceAgent.match(/(android)/)  ||
      deviceAgent.match(/(iemobile)/) ||
      deviceAgent.match(/iphone/i) ||
      deviceAgent.match(/ipad/i) ||
      deviceAgent.match(/ipod/i) ||
      deviceAgent.match(/blackberry/i) ||
      deviceAgent.match(/bada/i))) {
        return true;
      } else {
        return false;
      }
    }

    DeviceQueries.isMobileSize = function() {
      return window.innerWidth <= 767;
    }

    DeviceQueries.isTabletSize = function() {
      return (window.innerWidth >= 767 && window.innerWidth <= 1024);
    }

    DeviceQueries.isDesktopSize = function() {
      return (!this.isMobileSize() && !this.isTabletSize());
    }

    return DeviceQueries;
})();

$(document).on("ready page:load", function()
{
    DeviceQueries.init();
});
